import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { RoutingConstants } from "../../constants/routingConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { ReformsService } from "../reforms.service";
import { CommonService } from "src/app/core/services/common.service";

@Component({
  selector: "app-edit-reforms",
  templateUrl: "./edit-reforms.component.html",
  styleUrls: ["./edit-reforms.component.sass"],
})
export class EditReformsComponent implements OnInit {
  reform: any;
  public routing = RoutingConstants.reformsRouting;
  files = {
    es: "",
    en: "",
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrAlertService: ToastrAlertService,
    private reformsService: ReformsService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.initFormGroup();
    this.getReform();
  }

  initFormGroup() {
    this.reform = new FormGroup({
      reforma: new FormGroup({
        reId: new FormControl("", [
          Validators.required,
          Validators.maxLength(8),
        ]),
        padre: new FormControl("", Validators.maxLength(32)),
        reActivarOcultos: new FormControl("", Validators.maxLength(32)),
        reAnulada: new FormControl("", Validators.maxLength(32)),
        reDescr: new FormControl("", Validators.maxLength(32)),
        reFhCreacion: new FormControl("", Validators.maxLength(32)),
        reFhModificacion: new FormControl("", Validators.maxLength(32)),
        reFormulario: new FormControl("", Validators.maxLength(32)),
        reMarcolegal: new FormControl("", Validators.maxLength(32)),
        reTramitable: new FormControl("", Validators.maxLength(32)),
      }),
      ayudaEspanolDto: new FormGroup({
        ayAyuda: new FormControl([]),
        ayFichero: new FormControl(""),
        id: new FormControl("", Validators.maxLength(32)),
        idioma: new FormGroup({
          descr: new FormControl("Español", Validators.maxLength(32)),
          id: new FormControl("es", Validators.maxLength(32)),
        }),
      }),
      ayudaInglesDto: new FormGroup({
        ayAyuda: new FormControl([]),
        ayFichero: new FormControl(""),
        id: new FormControl("", Validators.maxLength(32)),
        idioma: new FormGroup({
          descr: new FormControl("Ingles", Validators.maxLength(32)),
          id: new FormControl("en", Validators.maxLength(32)),
        }),
      }),
    });
  }

  setValues(data): void {
    this.reform.patchValue({
      reforma: {
        reId: data.id.reId,
        padre: data.padre,
        reActivarOcultos: data.reActivarOcultos,
        reAnulada: data.reAnulada,
        reDescr: data.reDescr,
        reFhCreacion: data.reFhCreacion,
        reFhModificacion: data.reFhModificacion,
        reFormulario: data.reFormulario,
        reMarcolegal: data.id.reMarcolegal,
        reTramitable: data.reTramitable,
      },
    });
    data.ayudas.forEach((element) => {
      if (
        element.idioma &&
        element.idioma.idId &&
        element.idioma.idId === "es"
      ) {
        this.files.es = element.ayFichero;
        this.reform.patchValue({
          ayudaEspanolDto: {
            id: element.id,
          },
        });
      } else if (
        element.idioma &&
        element.idioma.idId &&
        element.idioma.idId === "en"
      ) {
        this.files.en = element.ayFichero;
        this.reform.patchValue({
          ayudaInglesDto: {
            id: element.id,
          },
        });
      }
    });
  }

  getReform() {
    if (this.activatedRoute.snapshot.params.id) {
      let id = this.activatedRoute.snapshot.params.id;
      this.reformsService.getReform(id).subscribe(
        (data) => {
          this.setValues(data);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }

  formatInfo() {
    if (this.reform.value.reforma.reActivarOcultos) {
      this.reform.value.reforma.reActivarOcultos = 1;
    } else {
      this.reform.value.reforma.reActivarOcultos = 0;
    }
    if (this.reform.value.reforma.reTramitable) {
      this.reform.value.reforma.reTramitable = 1;
    } else {
      this.reform.value.reforma.reTramitable = 0;
    }
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.reform.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      this.formatInfo();

      this.reformsService.updateReform(this.reform.value).subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(
            data.mensaje,
            this.routing.list
          );
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  setFileEsp(imgBase64) {
    let blob = this.commonService.castToBlob(imgBase64);
    this.reform.patchValue({
      ayudaEspanolDto: {
        ayAyuda: blob,
      },
    });
  }

  setFileEng(imgBase64) {
    let blob = this.commonService.castToBlob(imgBase64);
    this.reform.patchValue({
      ayudaInglesDto: {
        ayAyuda: blob,
      },
    });
  }

  handleFileInputEsp(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.files.es = fileInput.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.setFileEsp(e.target.result);
      };

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  handleFileInputEng(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.files.en = fileInput.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.setFileEng(e.target.result);
      };

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  download(idFichero, fileName) {
    this.reformsService.downloadAyudaFile(idFichero).subscribe(
      (data) => {
        this.commonService.downloadFile(data, fileName);
      },
      (err) => {
        this.toastrAlertService.toastFailBlob(err.error);
      }
    );
  }
}
